// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GoldStage__content--nAf0i {
    max-width: 400px;
    margin: 0 auto;
    width: 100%;
}

    @media screen and (min-width: 1024px) {.GoldStage__content--nAf0i {
        max-width: 640px
}

        .GoldStage__content--nAf0i.GoldStage__finish--TOVyP {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-height: calc(100vh - 160px);        
        }
    }

.GoldStage__contentWithFlex--dumWJ {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 24px);
}

@media screen and (min-width: 1024px) {

.GoldStage__contentWithFlex--dumWJ {
        min-height: calc(100vh - 160px)
}
    }

.GoldStage__wrapper--M17Vf {
    overflow: hidden;
    margin-bottom: 12px;
    position: relative;
}

.GoldStage__header--ZCZri {
    padding: 28px 0 52px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.GoldStage__logo--qZw_f {
    margin-bottom: 28px;
}

.GoldStage__logo--qZw_f img {
        width: 149px;
        height: 35px;
    }

.GoldStage__progressBarWrapper--xq74E {
    margin-bottom: 45px;
}

.GoldStage__cards--KUubA {
    width: 100%;
    max-width: 312px;
    margin: 0 auto;
    min-height: 365px;
    display: flex;
    justify-content: center;
    position: relative;
    margin-bottom: 24px;
}

.GoldStage__card--TtQ3j {
    position: relative;
    z-index: 2;
}

.GoldStage__card--TtQ3j:first-child {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    transform: rotate(-5deg);
}

.GoldStage__card--TtQ3j:first-child .GoldStage__starBlock--sj0Lc {
        margin-left: 24px;
        transform: rotate(5deg);
    }

.GoldStage__card--TtQ3j:first-child .GoldStage__starBlockBorder--apWaS {
        animation: GoldStage__spin--nz5Db 4s linear infinite;
    }

.GoldStage__card--TtQ3j:last-child {
    position: absolute;
    z-index: 1;
    bottom: 0;
    right: 0;
    transform: rotate(5deg);
}

.GoldStage__card--TtQ3j:last-child .GoldStage__starBlock--sj0Lc {
        margin-right: 28px;
        transform: rotate(-5deg);
    }

.GoldStage__card--TtQ3j:last-child .GoldStage__starBlockBorder--apWaS {
        animation: GoldStage__spin--nz5Db 6s linear infinite;
    }

.GoldStage__starBlock--sj0Lc {
    width: 44px;
    height: 44px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-bottom: 20px;
    cursor: pointer;
}

.GoldStage__starBlock--sj0Lc.GoldStage__active--FqnJY .GoldStage__starBlockBorder--apWaS {
        animation: none !important;
    }

.GoldStage__starBlock--sj0Lc:hover .GoldStage__starBlockBorder--apWaS {
        animation-play-state: paused !important;
    }

.GoldStage__starBlockBorder--apWaS {
    position: absolute;
    top: 0;
    left: 0;
    animation: GoldStage__spin--nz5Db 3s linear infinite;
}

.GoldStage__cardImage--O6gCs {
    width: 147px;
    height: 230px;
    box-shadow: 0 4px 4px 0px rgba(0, 0, 0, 0.45);
}

.GoldStage__scoresBlock--nO7xi {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    max-width: 360px;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 24px;
}

.GoldStage__scoresBlockItem--mkVPT {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
}

.GoldStage__scoresBlockItemLabel--opxm9 {
    color: rgba(255, 255, 255, 0.6);
    font-size: 10px;
    font-weight: 700;
    line-height: 16px;
    text-transform: uppercase;
}

.GoldStage__controlsBlock--oSUPQ {
    margin-top: auto;
    display: flex;
    flex-direction: column;
}

@media screen and (min-width: 1024px) {

.GoldStage__controlsBlock--oSUPQ {
        gap: 24px
}
    }

@media screen and (max-width: 1023px) {

.GoldStage__controlsBlock--oSUPQ {
        position: sticky;
        bottom: 0;
        left: 0;
        background: linear-gradient(0deg, #181819 68.12%, rgba(24, 24, 25, 0.00) 100%);
        padding: 16px;
        width: calc(100% + 32px);
        z-index: 20;
        margin-left: -16px;
        gap: 36px
}
    }

.GoldStage__teamPower--Ek9ED {
    margin-top: auto;
}

.GoldStage__teamPowerTitle--yeLWf {
    color: #94A5CD;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

@media screen and (min-width: 1024px) {

.GoldStage__teamPowerTitle--yeLWf {
        font-size: 20px;
        line-height: 28px
}
    }

.GoldStage__teamPowerFinalBlock--xL_ax {
    color: #FFD370;
    text-shadow: 0 2px 2px rgba(0, 0, 0, 0.45);
    font-size: 36px;
    line-height: 42px;
    font-style: italic;
    font-weight: 700;
    margin-top: 24px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.GoldStage__teamPowerFinalBlock--xL_ax > p {
        transform: rotate(-8deg);
    }

.GoldStage__teamPowerFinalBlock--xL_ax > p:nth-child(2) span {
        font-size: 30px;
        line-height: 35px;
    }

.GoldStage__footer--g7Khl {
    margin-top: 68px;
}

.GoldStage__footerWrapper--SQr9H {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.GoldStage__imageDecor--rnuCL {
    width: 126px;
    height: 6px;
    margin: 0 auto;
    display: block;
}

.GoldStage__imageDecor--rnuCL.GoldStage__top--sx4xA {
        margin-bottom: 24px;
    }

.GoldStage__imageDecor--rnuCL.GoldStage__bottom--x17QZ {
        margin-top: 24px;
    }

.GoldStage__imageWinner--m9ZeA {
    width: 100%;
    max-width: 348px;
    height: auto;
    aspect-ratio: 3.6 / 4.85;
    display: block;
    margin: 0 auto;
}

@media screen and (max-width: 518px) {

.GoldStage__imageWinner--m9ZeA {
        width: calc(100% + 32px)
}
    }

@media screen and (max-width: 375px) {

.GoldStage__imageWinner--m9ZeA {
        max-width: 320px
}
    }

@media screen and (min-width: 1024px) {

.GoldStage__imageWinner--m9ZeA {
        margin-bottom: 60px
}
    }

.GoldStage__footerFinish--iVkqs {
    position: fixed;
    padding: 16px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 360px;
}

@media screen and (max-width: 518px) {

.GoldStage__footerFinish--iVkqs {
        max-width: 100%
}
    }

@media screen and (min-width: 1024px) {

.GoldStage__footerFinish--iVkqs {
        position: static;
        max-width: 312px;
        transform: none;
        padding: 0;
        margin: 0 auto
}
    }

/* modal */
.GoldStage__overlay--rZ46O {
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-backdrop-filter: blur(22px);
            backdrop-filter: blur(22px);
}

.GoldStage__modal--qI21F {
    background-color: transparent;
    border: none;
    box-shadow: none;
    width: 100vw;
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 28px;
}

.GoldStage__modalImage--b60ze {
    width: 160px;
    height: 160px;
    opacity: 0;
    transition: opacity 0.15s linear;
    transition-delay: 0.1s;
}

.GoldStage__modalImage--b60ze.GoldStage__withAnimation--JJCBf {
        opacity: 1;
    }

.GoldStage__modalText--iHyf5 {
    color: var(--tertiary-color);
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    max-width: 312px;
    display: block;
}

@media screen and (min-width: 1024px) {

.GoldStage__modalText--iHyf5 {
        font-size: 22px;
        line-height: 28px
}
    }

.GoldStage__modalTextUppercase--DvnFc {
    text-transform: uppercase;
}

.GoldStage__modalWrapper--sDPNs {
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 0;
    transition: opacity 0.15s linear;
    transition-delay: 0.35s;
    position: relative;
}

.GoldStage__modalWrapper--sDPNs.GoldStage__withAnimation--JJCBf {
        opacity: 1;
    }

.GoldStage__ratingImage--AQS53 {
    width: 82px;
    height: 80px;
    position: absolute;
    right: 12px;
    bottom: 0;
    transform: translateY(100%);
}

.GoldStage__modalFooter--XUIey {
    position: absolute;
    padding: 24px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 360px;
}

.GoldStage__modalFooter--XUIey.GoldStage__withChildren--_rWGe {
        display: grid;
        grid-template-columns: 3fr 1fr;
        grid-gap: 12px;
    }

@media screen and (max-width: 518px) {

.GoldStage__modalFooter--XUIey {
        max-width: 100%
}
    }

.GoldStage__fullButton--pUC8x {
    width: 100%;
}

.GoldStage__controlButton--qiLl3 {
    width: 100%;
}

@media screen and (min-width: 1024px) {

.GoldStage__controlButton--qiLl3 {
        max-width: 312px;
        margin: 0 auto
}
    }

.GoldStage__secondaryButton--jpiYp {
    border-color: transparent;
    background-color: #1E2028;
}

.GoldStage__secondaryButton--jpiYp:hover {
        border-color: transparent;
    }

.GoldStage__secondaryButton--jpiYp:active {
        border-color: transparent;
    }

@keyframes GoldStage__spin--nz5Db { 
    100% { 
        transform: rotate(360deg); 
    } 
}
`, "",{"version":3,"sources":["webpack://./src/components/Plelander/GoldStage/GoldStage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AAYf;;IAVI,uCALJ;QAMQ;AASR;;QAPQ;YACI,aAAa;YACb,sBAAsB;YACtB,8BAA8B;YAC9B,+BAA+B;QACnC;IACJ;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAKlC;;AAHI;;AALJ;QAMQ;AAER;IADI;;AAGJ;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AAMvB;;AAJI;QACI,YAAY;QACZ,YAAY;IAChB;;AAGJ;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,OAAO;IACP,wBAAwB;AAU5B;;AARI;QACI,iBAAiB;QACjB,uBAAuB;IAC3B;;AAEA;QACI,oDAAkC;IACtC;;AAGJ;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,QAAQ;IACR,uBAAuB;AAU3B;;AARI;QACI,kBAAkB;QAClB,wBAAwB;IAC5B;;AAEA;QACI,oDAAkC;IACtC;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,mBAAmB;IACnB,eAAe;AASnB;;AAPI;QACI,0BAA0B;IAC9B;;AAEA;QACI,uCAAuC;IAC3C;;AAGJ;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,oDAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAiB1B;;AAfI;;AALJ;QAMQ;AAcR;IAbI;;AAEA;;AATJ;QAUQ,gBAAgB;QAChB,SAAS;QACT,OAAO;QACP,8EAA8E;QAC9E,aAAa;QACb,wBAAwB;QACxB,WAAW;QACX,kBAAkB;QAClB;AAER;IADI;;AAGJ;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AAMtB;;AAJI;;AATJ;QAUQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,cAAc;IACd,0CAA0C;IAC1C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AAUZ;;AARI;QACI,wBAAwB;IAC5B;;AAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;AAGJ;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,cAAc;AASlB;;AAPI;QACI,mBAAmB;IACvB;;AAEA;QACI,gBAAgB;IACpB;;AAGJ;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,cAAc;IACd,cAAc;AAalB;;AAXI;;AARJ;QASQ;AAUR;IATI;;AAEA;;AAZJ;QAaQ;AAMR;IALI;;AAEA;;AAhBJ;QAiBQ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;AAapB;;AAXI;;AATJ;QAUQ;AAUR;IATI;;AAEA;;AAbJ;QAcQ,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,UAAU;QACV;AAER;IADI;;AAGJ,UAAU;AACV;IACI,oCAAoC;IACpC,mCAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,UAAU;IACV,gCAAgC;IAChC,sBAAsB;AAK1B;;AAHI;QACI,UAAU;IACd;;AAGJ;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAMlB;;AAJI;;AARJ;QASQ,eAAe;QACf;AAER;IADI;;AAGJ;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,gCAAgC;IAChC,uBAAuB;IACvB,kBAAkB;AAKtB;;AAHI;QACI,UAAU;IACd;;AAGJ;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;AAWpB;;AATI;QACI,aAAa;QACb,8BAA8B;QAC9B,cAAc;IAClB;;AAEA;;AAfJ;QAgBQ;AAER;IADI;;AAGJ;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AAMf;;AAJI;;AAHJ;QAIQ,gBAAgB;QAChB;AAER;IADI;;AAGJ;IACI,yBAAyB;IACzB,yBAAyB;AAS7B;;AAPI;QACI,yBAAyB;IAC7B;;AAEA;QACI,yBAAyB;IAC7B;;AAGJ;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".content {\n    max-width: 400px;\n    margin: 0 auto;\n    width: 100%;\n\n    @media (--large) {\n        max-width: 640px;\n\n        &.finish {\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            min-height: calc(100vh - 160px);        \n        }\n    }\n}\n\n.contentWithFlex {\n    display: flex;\n    flex-direction: column;\n    min-height: calc(100vh - 24px);\n\n    @media (--large) {\n        min-height: calc(100vh - 160px);\n    }\n}\n\n.wrapper {\n    overflow: hidden;\n    margin-bottom: 12px;\n    position: relative;\n}\n\n.header {\n    padding: 28px 0 52px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.logo {\n    margin-bottom: 28px;\n\n    img {\n        width: 149px;\n        height: 35px;\n    }\n}\n\n.progressBarWrapper {\n    margin-bottom: 45px;\n}\n\n.cards {\n    width: 100%;\n    max-width: 312px;\n    margin: 0 auto;\n    min-height: 365px;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    margin-bottom: 24px;\n}\n\n.card {\n    position: relative;\n    z-index: 2;\n}\n\n.card:first-child {\n    position: absolute;\n    z-index: 1;\n    bottom: 0;\n    left: 0;\n    transform: rotate(-5deg);\n\n    .starBlock {\n        margin-left: 24px;\n        transform: rotate(5deg);\n    }\n\n    .starBlockBorder {\n        animation: spin 4s linear infinite;\n    }\n}\n\n.card:last-child {\n    position: absolute;\n    z-index: 1;\n    bottom: 0;\n    right: 0;\n    transform: rotate(5deg);\n\n    .starBlock {\n        margin-right: 28px;\n        transform: rotate(-5deg);\n    }\n\n    .starBlockBorder {\n        animation: spin 6s linear infinite;\n    }\n}\n\n.starBlock {\n    width: 44px;\n    height: 44px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    margin-bottom: 20px;\n    cursor: pointer;\n\n    &.active .starBlockBorder {\n        animation: none !important;\n    }\n\n    &:hover .starBlockBorder {\n        animation-play-state: paused !important;\n    }\n}\n\n.starBlockBorder {\n    position: absolute;\n    top: 0;\n    left: 0;\n    animation: spin 3s linear infinite;\n}\n\n.cardImage {\n    width: 147px;\n    height: 230px;\n    box-shadow: 0 4px 4px 0px rgba(0, 0, 0, 0.45);\n}\n\n.scoresBlock {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-gap: 16px;\n    max-width: 360px;\n    width: 100%;\n    margin: 0 auto;\n    margin-bottom: 24px;\n}\n\n.scoresBlockItem {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 100%;\n}\n\n.scoresBlockItemLabel {\n    color: rgba(255, 255, 255, 0.6);\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 16px;\n    text-transform: uppercase;\n}\n\n.controlsBlock {\n    margin-top: auto;\n    display: flex;\n    flex-direction: column;\n\n    @media (--large) {\n        gap: 24px;\n    }\n\n    @media (--mobile) {\n        position: sticky;\n        bottom: 0;\n        left: 0;\n        background: linear-gradient(0deg, #181819 68.12%, rgba(24, 24, 25, 0.00) 100%);\n        padding: 16px;\n        width: calc(100% + 32px);\n        z-index: 20;\n        margin-left: -16px;\n        gap: 36px;\n    }\n}\n\n.teamPower {\n    margin-top: auto;\n}\n\n.teamPowerTitle {\n    color: #94A5CD;\n    text-align: center;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 20px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n\n    @media (--large) {\n        font-size: 20px;\n        line-height: 28px;\n    }\n}\n\n.teamPowerFinalBlock {\n    color: #FFD370;\n    text-shadow: 0 2px 2px rgba(0, 0, 0, 0.45);\n    font-size: 36px;\n    line-height: 42px;\n    font-style: italic;\n    font-weight: 700;\n    margin-top: 24px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    > p {\n        transform: rotate(-8deg);\n    }\n\n    > p:nth-child(2) span {\n        font-size: 30px;\n        line-height: 35px;\n    }\n}\n\n.footer {\n    margin-top: 68px;\n}\n\n.footerWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n}\n\n.imageDecor {\n    width: 126px;\n    height: 6px;\n    margin: 0 auto;\n    display: block;\n\n    &.top {\n        margin-bottom: 24px;\n    }\n\n    &.bottom {\n        margin-top: 24px;\n    }\n}\n\n.imageWinner {\n    width: 100%;\n    max-width: 348px;\n    height: auto;\n    aspect-ratio: 3.6 / 4.85;\n    display: block;\n    margin: 0 auto;\n\n    @media (--tiny-only) {\n        width: calc(100% + 32px);\n    }\n\n    @media screen and (max-width: 375px) {\n        max-width: 320px;\n    }\n\n    @media (--large) {\n        margin-bottom: 60px;\n    }\n}\n\n.footerFinish {\n    position: fixed;\n    padding: 16px;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 360px;\n\n    @media (--tiny-only) {\n        max-width: 100%;\n    }\n\n    @media (--large) {\n        position: static;\n        max-width: 312px;\n        transform: none;\n        padding: 0;\n        margin: 0 auto;\n    }\n}\n\n/* modal */\n.overlay {\n    background-color: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(22px);\n}\n\n.modal {\n    background-color: transparent;\n    border: none;\n    box-shadow: none;\n    width: 100vw;\n    height: 100vh;\n    max-width: 100%;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 28px;\n}\n\n.modalImage {\n    width: 160px;\n    height: 160px;\n    opacity: 0;\n    transition: opacity 0.15s linear;\n    transition-delay: 0.1s;\n\n    &.withAnimation {\n        opacity: 1;\n    }\n}\n\n.modalText {\n    color: var(--tertiary-color);\n    text-align: center;\n    font-size: 18px;\n    font-weight: 500;\n    max-width: 312px;\n    display: block;\n\n    @media (--large) {\n        font-size: 22px;\n        line-height: 28px;\n    }\n}\n\n.modalTextUppercase {\n    text-transform: uppercase;\n}\n\n.modalWrapper {\n    max-width: 360px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    opacity: 0;\n    transition: opacity 0.15s linear;\n    transition-delay: 0.35s;\n    position: relative;\n\n    &.withAnimation {\n        opacity: 1;\n    }\n}\n\n.ratingImage {\n    width: 82px;\n    height: 80px;\n    position: absolute;\n    right: 12px;\n    bottom: 0;\n    transform: translateY(100%);\n}\n\n.modalFooter {\n    position: absolute;\n    padding: 24px;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 360px;\n\n    &.withChildren {\n        display: grid;\n        grid-template-columns: 3fr 1fr;\n        grid-gap: 12px;\n    }\n\n    @media (--tiny-only) {\n        max-width: 100%;\n    }\n}\n\n.fullButton {\n    width: 100%;\n}\n\n.controlButton {\n    width: 100%;\n\n    @media (--large) {\n        max-width: 312px;\n        margin: 0 auto;\n    }\n}\n\n.secondaryButton {\n    border-color: transparent;\n    background-color: #1E2028;\n\n    &:hover {\n        border-color: transparent;\n    }\n\n    &:active {\n        border-color: transparent;\n    }\n}\n\n@keyframes spin { \n    100% { \n        transform: rotate(360deg); \n    } \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `GoldStage__content--nAf0i`,
	"finish": `GoldStage__finish--TOVyP`,
	"contentWithFlex": `GoldStage__contentWithFlex--dumWJ`,
	"wrapper": `GoldStage__wrapper--M17Vf`,
	"header": `GoldStage__header--ZCZri`,
	"logo": `GoldStage__logo--qZw_f`,
	"progressBarWrapper": `GoldStage__progressBarWrapper--xq74E`,
	"cards": `GoldStage__cards--KUubA`,
	"card": `GoldStage__card--TtQ3j`,
	"starBlock": `GoldStage__starBlock--sj0Lc`,
	"starBlockBorder": `GoldStage__starBlockBorder--apWaS`,
	"spin": `GoldStage__spin--nz5Db`,
	"active": `GoldStage__active--FqnJY`,
	"cardImage": `GoldStage__cardImage--O6gCs`,
	"scoresBlock": `GoldStage__scoresBlock--nO7xi`,
	"scoresBlockItem": `GoldStage__scoresBlockItem--mkVPT`,
	"scoresBlockItemLabel": `GoldStage__scoresBlockItemLabel--opxm9`,
	"controlsBlock": `GoldStage__controlsBlock--oSUPQ`,
	"teamPower": `GoldStage__teamPower--Ek9ED`,
	"teamPowerTitle": `GoldStage__teamPowerTitle--yeLWf`,
	"teamPowerFinalBlock": `GoldStage__teamPowerFinalBlock--xL_ax`,
	"footer": `GoldStage__footer--g7Khl`,
	"footerWrapper": `GoldStage__footerWrapper--SQr9H`,
	"imageDecor": `GoldStage__imageDecor--rnuCL`,
	"top": `GoldStage__top--sx4xA`,
	"bottom": `GoldStage__bottom--x17QZ`,
	"imageWinner": `GoldStage__imageWinner--m9ZeA`,
	"footerFinish": `GoldStage__footerFinish--iVkqs`,
	"overlay": `GoldStage__overlay--rZ46O`,
	"modal": `GoldStage__modal--qI21F`,
	"modalImage": `GoldStage__modalImage--b60ze`,
	"withAnimation": `GoldStage__withAnimation--JJCBf`,
	"modalText": `GoldStage__modalText--iHyf5`,
	"modalTextUppercase": `GoldStage__modalTextUppercase--DvnFc`,
	"modalWrapper": `GoldStage__modalWrapper--sDPNs`,
	"ratingImage": `GoldStage__ratingImage--AQS53`,
	"modalFooter": `GoldStage__modalFooter--XUIey`,
	"withChildren": `GoldStage__withChildren--_rWGe`,
	"fullButton": `GoldStage__fullButton--pUC8x`,
	"controlButton": `GoldStage__controlButton--qiLl3`,
	"secondaryButton": `GoldStage__secondaryButton--jpiYp`
};
export default ___CSS_LOADER_EXPORT___;
